<template>
  <v-autocomplete
    data-private
    dense
    multiple
    clearable
    outlined
    ref="multipleSelect"
    :cache-items="cacheItems"
    :hint="hint"
    :hide-details="hideDetails"
    :rules="rules"
    :required="required"
    :loading="loading"
    :disabled="disabled || loading"
    :item-value="itemValue"
    :item-text="itemText"
    :menu-props="{ offsetY: true }"
    :items="options"
    :label="label"
    :persistent-hint="persistentHint"
    :placeholder="$t('common.select_option')"
    :prepend-icon="icon"
    :value="value"
    :search-input.sync="searchTerm"
    @change="handleChange"
  >
    <template v-slot:selection="{ item, index }">
      <v-chip outlined small v-if="index < maxChipsShown" class="mt-1">
        <span v-if="index < lastChip">{{ item[itemText] }}</span>
        <span v-if="index === lastChip">{{
          $t('common.plusOthersWithCount_other', {
            count: value.length - lastChip,
          })
        }}</span>
      </v-chip>
    </template>
  </v-autocomplete>
</template>

<script>
const MAX_CHIPS_SHOWN = 4

import _ from 'lodash'

export default {
  name: 'MultipleSelect',

  props: {
    cacheItems: { type: Boolean, required: false, default: true },
    disabled: Boolean,
    required: { type: Boolean, required: false, default: false },
    itemValue: { type: String, required: false, default: '_id' },
    itemText: { type: String, required: false, default: 'name' },
    value: { type: Array, required: true },
    options: { type: Array, required: true },
    label: { type: String, required: false },
    icon: { type: String, required: false },
    loading: { type: Boolean, required: false, default: false },
    hideDetails: { type: Boolean, required: false, default: false },
    hint: { type: String, required: false },
    persistentHint: { type: Boolean, required: false, default: false },
    maxChipsShown: { type: Number, required: false, default: MAX_CHIPS_SHOWN },
  },

  data() {
    return {
      searchTerm: null,
    }
  },
  watch: {
    searchTerm: _.debounce(function(term) {
      this.$emit('search', term)
    }, 500),
  },

  computed: {
    lastChip() {
      return this.maxChipsShown - 1
    },

    cachedItems() {
      return this.$refs?.multipleSelect?.cachedItems?.length
        ? this.$refs?.multipleSelect?.cachedItems
        : this.options
    },

    rules() {
      if (!this.required) return []
      return [
        field =>
          Boolean(field.length) ||
          this.$t('validation.form.this_field_is_required'),
      ]
    },
  },

  methods: {
    handleChange(items) {
      this.searchTerm = ''

      this.$emit('change', items)
    },
  },
}
</script>
